<template>
  <div class="inspectionReport">
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="inspectionReport.pkid > 0 ? '质量检验编辑':'质量检验新建'"
        class="customer-edit"
        width="1200px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          style="position: relative"
          :model="inspectionReport"
          :rules="ruleValidate"
          class="form"
          label-width="120px">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="基本信息" name="first">
            <div class="WrongInfoPage" style="display: none">
              <table class="printTable" tyle="width: 100%" cellpadding="0" cellspacing="0">
                <tr>
                  <td class="tableLabel">条码:</td>
                  <td>{{barCode}}</td>
                  <td class="tableLabel">客户名称:</td>
                  <td>{{inspectionReport.customerName}}</td>
                  <td class="tableLabel">出厂编号:</td>
                  <td>{{inspectionReport.pcNo}}</td>
                </tr>
                <tr>
                  <td class="tableLabel">检验类型:</td>
                  <td v-if="inspectionReport.storageInspectionType === 10">控制柜</td>
                  <td v-if="inspectionReport.storageInspectionType === 20">人机</td>
                  <td class="tableLabel">检验员:</td>
                  <td>{{inspectionReport.inspectorName}}</td>
                  <td class="tableLabel">检验时间:</td>
                  <td>{{inspectionReport.createdTime.substring(0,10)}}</td>
                </tr>
                <tr>
                  <td class="tableLabel">物料号:</td>
                  <td>{{inspectionReport.materialNo}}</td>
                  <td class="tableLabel">物料描述:</td>
                  <td colspan="3">{{inspectionReport.materialName}}</td>
                </tr>
                <tr>
                  <td class="tableLabel">供应商:</td>
                  <td>{{inspectionReport.supplierName}}</td>
                  <td class="tableLabel">不良数量:</td>
                  <td>{{inspectionReport.badQuality}}</td>
                  <td class="tableLabel">指定通知人:</td>
                  <td>{{inspectionReport.notifierName}}</td>
                </tr>
                <tr>
                  <td class="tableLabel">基准:</td>
                  <td>{{inspectionReport.standards}}</td>
                  <td class="tableLabel">实际:</td>
                  <td>{{inspectionReport.practical}}</td>
                  <td class="tableLabel">问题分类:</td>
                  <td>{{inspectionReport.problemClassification}}</td>
                </tr>
                <tr>
                  <td class="tableLabel">区域负责工程师:</td>
                  <td>{{inspectionReport.regionalManager}}</td>
                  <td class="tableLabel">责任部门接口人:</td>
                  <td>{{inspectionReport.responsibleName}}</td>
                  <td class="tableLabel">责任部门:</td>
                  <td>{{inspectionReport.responsibleDepartment}}</td>
                </tr>
                <tr>
                  <td class="tableLabel">是否处理：</td>
                  <td>{{inspectionReport.needHandle?"是":"否"}}</td>
                  <td v-if="inspectionReport.needHandle === false" class="tableLabel">备注：</td>
                  <td v-if="inspectionReport.needHandle === false" colspan="3">{{inspectionReport.note}}</td>
                  <td v-if="inspectionReport.needHandle" class="tableLabel">处理人：</td>
                  <td v-if="inspectionReport.needHandle" colspan="3">{{inspectionReport.handleName}}</td>
                </tr>
                <tr>
                  <td class="tableLabel">问题初步调查:</td>
                  <td colspan="5">{{inspectionReport.preliminaryInvestigation}}</td>
                </tr>
              </table>
            </div>
            <el-row>
              <el-col :span="8">
                <el-form-item label="条码：">
                  <el-input v-model="barCode" placeholder="请输入"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="客户名称：">
                  <el-input v-model="inspectionReport.customerName"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="出厂编号：">
                  <el-input v-model="inspectionReport.pcNo"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="检验类型：">
                  <el-radio-group v-model="inspectionReport.storageInspectionType" disabled>
                    <el-radio :label="10">控制柜</el-radio>
                    <el-radio :label="20">人机</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="检验员：">
                  <el-input v-model="inspectionReport.inspectorName"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="检验时间：">
                  <el-input v-model="inspectionReport.createdTime"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="物料号：">
                  <el-input v-model="inspectionReport.materialNo" @change="selectNameByNo"/>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item label="物料描述：">
                  <el-input v-model="inspectionReport.materialName"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="供应商：">
                  <el-input v-model="inspectionReport.supplierName" placeholder="请选择" readonly>
                    <el-button slot="append" icon="el-icon-search" @click="$refs.selectSupplierManage.open()"/>
                  </el-input>
                  <supplier-manage-select ref="selectSupplierManage" @select="onSelectSupplier"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="不良数量：" :span="8">
                  <el-input v-model="inspectionReport.badQuality" type="number" min="1"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="指定通知人">
                  <el-input v-model="inspectionReport.notifierName" clearable placeholder="请选择指定通知人">
                    <el-button slot="append" icon="el-icon-search" @click="$refs.notifier.open()"/>
                  </el-input>
                  <user-select ref="notifier" @select="selectNotifier"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="基准：">
                  <el-input v-model="inspectionReport.standards"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="实际：">
                  <el-input v-model="inspectionReport.practical"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="问题分类：">
                  <el-select
                      v-if="inspectionReport.storageInspectionType === 10"
                      v-model.trim="inspectionReport.problemClassification"
                      clearable
                      placeholder="请选择">
                    <el-option
                        v-for="item in constants.problemClassification_KZG.$options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"/>
                  </el-select>
                  <el-select
                      v-if="inspectionReport.storageInspectionType === 20"
                      v-model.trim="inspectionReport.problemClassification"
                      clearable
                      placeholder="请选择">
                    <el-option
                        v-for="item in constants.problemClassification_RJ.$options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="区域负责工程师：">
                  <el-input v-model="inspectionReport.regionalManager" placeholder="请选择" readonly>
                    <el-button slot="append" icon="el-icon-search" @click="$refs.selectRegionalManager.open()"/>
                  </el-input>
                  <user-select ref="selectRegionalManager" @select="selectRegionalManager"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="责任部门接口人：">
                  <el-input v-model="inspectionReport.responsibleName" placeholder="请选择" readonly>
                    <el-button slot="append" icon="el-icon-search" @click="$refs.selectResponsibleName.open()"/>
                  </el-input>
                  <user-select ref="selectResponsibleName" @select="onSelectResponsibleName"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="责任部门：">
                  <el-input v-model="inspectionReport.responsibleDepartment"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="是否处理：">
                  <el-radio-group v-model="inspectionReport.needHandle">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col v-if="inspectionReport.needHandle === false" :span="16">
                <el-form-item label="备注：">
                  <el-input v-model="inspectionReport.note" placeholder="请选择" readonly/>
                </el-form-item>
              </el-col>
              <el-col v-if="inspectionReport.needHandle" :span="8">
                <el-form-item label="处理人：">
                  <el-input v-model="inspectionReport.handleName" placeholder="请选择" readonly>
                    <el-button slot="append" icon="el-icon-search" @click="$refs.selectHandle.open()"/>
                  </el-input>
                  <user-select ref="selectHandle" @select="onSelectHandle"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="问题初步调查：">
                  <el-input v-model="inspectionReport.preliminaryInvestigation" type="textarea"/>
                </el-form-item>
              </el-col>
            </el-row>

            <div style="padding: 0 0 10px 10px;width: 90%;margin: 0 auto">
              <div>
                <el-form
                    ref="formUplosd"
                    enctype="multipart/form-data"
                    label-position="right"
                    label-width="120px"
                    size="mini">
                  <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between">
                    <div>
                      <div v-if="!inspectionReport.accessoryList || !inspectionReport.accessoryList.length">暂无附件</div>
                      <table width="100%">
                        <tr v-for="(item, index) in inspectionReport.accessoryList" :key="index">
                          <td>附件{{index + 1}}</td>
                          <td style="cursor: pointer;padding:5px;color: #20a0ff" @click="openFile(item)">{{item.fileName}}</td>
                          <td style="padding:5px"><el-input v-model="item.note" size="mini"/></td>
                          <td style="padding:5px;color: #20a0ff;cursor: pointer;" @click="deleteFile(index)">删除</td>
                        </tr>
                      </table>
                    </div>
                    <div>
                      <el-upload
                          action=""
                          multiple
                          :http-request="submitUpload"
                          :show-file-list="false"
                          :disabled="uploadLoading"
                          style="display: inline-block; float: right; margin: 5px;">
                        <el-button type="primary" plain>
                          <i class="el-icon-upload el-icon--right"/>
                          附件上传
                        </el-button>
                      </el-upload>
                    </div>
                  </div>
                </el-form>
              </div>
            </div>
            <div>
              <el-button type="primary" @click="printPage">打印</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane v-if="inspectionReport.pkid > 0" label="报告状态" name="third">
            <el-table
                :data="inspectionReport.inspectionMaterials"
                default-expand-all
                style="width: 100%;margin-top: 3px">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-table
                      :data="props.row.inspectionResults"
                      default-expand-all
                      style="width: 100%;margin-top: 3px">
                    <el-table-column align="center" label="检验项名称" prop="name"/>
                    <el-table-column align="center" label="检验标准" prop="inspectionStandard"/>
                    <el-table-column align="center" label="初检结果" prop="initialInspectionResult"/>
                    <el-table-column align="center" label="复检结果" prop="inspectionResult"/>
                    <el-table-column
                        label="操作"
                        align="center"
                        class-name="vm-table_operate"
                        width="180px">
                      <template slot-scope="scope">
                        <el-button
                            type="primary"
                            @click="watchPicture(scope.row)">
                          图片查看
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <picture-list ref="pictureList"/>
                </template>
              </el-table-column>
              <el-table-column prop="materialNO">
                <template slot-scope="scope">
                  <span style="font-weight: bold">{{scope.row.materialNO}}</span>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane v-if="inspectionReport.pkid > 0" label="工作流详情" name="fourth">
            <handle-detail :bill-id="billId" :bill-type="billType" sequ-id="-1"/>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <span slot="footer">
        <el-button type="info" @click="dialogVisible=false">关闭</el-button>
        <el-button :disabled="currentUser!==inspectionReport.inspectorID" :loading="saveLoading" type="primary" @click="reportSave">保存</el-button>
        <el-button
            :disabled="currentUser!==inspectionReport.inspectorID"
            :loading="submitLoading"
            type="primary"
            @click="reportSubmit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "../../../util/constant";
  import constants from "../../../util/constants";
  import EmployeeSelect from "@/views/information/Employee/EmployeeSelect";
  import SupplierManageSelect from "@/views/information/SupplierManage/SupplierManageSelect";
  import PictureList from "@/views/purchase/inspectionReport/pictureList";
  import UserSelect from "@/views/SystemInfo/SystemUser/UserSelect";
  import HandleDetail from "@/views/workFlow/HandleDetail";
  import loginUtil from "@/util/loginUtil";
  import auth from "@/util/loginUtil";

  export default {
    name: "InspectionReportEdit",
    components: {UserSelect, SupplierManageSelect, PictureList, HandleDetail},
    data() {
      return {
        constant,
        constants,
        currentUser: auth.getUserId(),
        editAuth: this.$auth(832),
        uploadLoading: false,
        billId: "0",
        billType: "23",
        handleType: constant.toSelect(constant.handleType),
        exportLoading: false,
        statu: constant.toSelect(constant.purchaseStatus, "addAll"),
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        saveLoading: false,
        activeName: "first",
        barCode: "",
        value: "",
        inspectionReport: {
          pkid: 0,
          barCode: "",
          no: "",
          billID: "",
          billType: "",
          notifierName: "",
          notifierId: "",
          qualityWorkingHours: "",
          inspectionType: 20,
          storageInspectionType: 10,
          conclusion: 0,
          inspectionResult: false,
          needHandle: true,
          note:"",
          handleType: 10,
          materialNo: "",
          materialName: "",
          handleDepartment: "",
          standards: "",
          practical: "",
          problemClassification: "",
          preliminaryInvestigation: "",
          responsibleDepartment: "",
          responsibleID: "",
          responsibleName: "",
          supplierID: "",
          supplierName: "",
          regionalID: "",
          regionalManager: "",
          handleID: "",
          handleName: "",
          qualitativeClassification: "",
          createdTime: "",
          inspectorName: "",
          accessoryList: [],
          submissionNum: "",
          spotCheckNum: "",
          unqualifiedNum: "",
        },
        ruleValidate: {
          regionalManager: {required: true, message: "不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(row) {
        this.inspectionReport.billID = row.billID;
        this.billId = row.pkid + "";
        this.barCode = row.barcode;
        this.dialogVisible = true;
        if (this.inspectionReport.billID > 0) {
          this.getData();
        }
      },
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `inspectionReports/selectControlBoxReportById/${this.inspectionReport.billID}`)
          .then(resp => {
            console.log(resp);
            this.inspectionReport = resp;
            this.contentLoading = false;
          });
      },
      watchPicture(row) {
        console.log(this.inspectionReport.controlBoxFlow.techParamBillNo);
        console.log(this.inspectionReport.pcNo);
        let pcNo = this.inspectionReport.pcNo;
        
        if (pcNo ==null || pcNo == "") {
          pcNo = this.inspectionReport.controlBoxFlow.techParamBillNo;
        }
        this.$refs.pictureList.open(row.photos,pcNo);
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/batch/0", formData)
          .then((res) => {
            this.uploadLoading = false;
            // this.saveAttachments(res.data.attachments, 0);
            const fileInfo = res.data.attachments[0];
            console.log(fileInfo);
            this.inspectionReport.accessoryList.push({
              fileName: fileInfo.fileName,
              filePath: "/attached/file/" + fileInfo.filePath,
              note: "",
            });
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },
      deleteFile(index) {
        this.inspectionReport.accessoryList.splice(index, 1);
      },
      openFile(item) {
        console.log(item);
        let a = document.createElement("a");
        a.href = "http://emes.stepelectric.com" + item.filePath;
        a.target = "_blank";
        a.download = item.filePath;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      },
      //打印
      printPage() {
        var printPage = document.querySelector(".WrongInfoPage").innerHTML;
        var oldPage = document.body.innerHTML;
        document.body.innerHTML = printPage;
        window.print();
        window.location.reload();
      },
      getFormatDate(date) {
        let month = date.getMonth() + 1;
        let strDate = date.getDate();
        let hours = date.getHours();
        let minutes = date.getMinutes();
        let seconds = date.getSeconds();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        if (hours >= 0 && hours <= 9) {
          hours = "0" + hours;
        }
        if (minutes >= 0 && minutes <= 9) {
          minutes = "0" + minutes;
        }
        if (seconds >= 0 && seconds <= 9) {
          seconds = "0" + seconds;
        }
        return date.getFullYear() + "-" + month + "-" + strDate + " " + hours + ":" + minutes + ":" + seconds;
      },
      onSelectHandle(row) {
        this.inspectionReport.handleID = row.systemUserID;
        this.inspectionReport.handleName = row.employeeName;
      },
      selectNotifier(row) {
        this.inspectionReport.notifierId = row.systemUserID;
        this.inspectionReport.notifierName = row.employeeName;
      },
      onSelectResponsibleName(row) {
        console.log(row);
        this.inspectionReport.responsibleID = row.systemUserID;
        this.inspectionReport.responsibleName = row.employeeName;
        this.inspectionReport.responsibleDepartment = row.departmentName;
      },
      selectRegionalManager(row) {
        this.inspectionReport.regionalID = row.systemUserID;
        this.inspectionReport.regionalManager = row.employeeName;
      },
      onSelectCountersign(row) {
        this.inspectionReport.countersignID = row.systemUserID;
        this.inspectionReport.countersignName = row.employeeName;
      },
      onSelectRework(row) {
        this.inspectionReport.reworkID = row.systemUserID;
        this.inspectionReport.reworkName = row.employeeName;
      },
      onSelectSupplier(row) {
        this.inspectionReport.supplierID = row.pkid;
        this.inspectionReport.supplierName = row.name;
      },
      downloadExcel(row) {
        console.log(row.filePath);
        let a = document.createElement("a");
        a.href = row.filePath;
        a.download = row.accessoryName;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      },
      selectNameByNo() {
        if (this.inspectionReport.materialNo.length > 0) {
          let params = {
            no: this.inspectionReport.materialNo,
          };
          this.$http
            .get("basic", "baseMaterials/selectNameByNo", params)
            .then((res) => {
              this.inspectionReport.materialName = res;
              console.log(res);
            });
        }

      },
      reportSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.saveLoading = true;
            this.$http
              .post("basic", "inspectionReports/reportSave", this.inspectionReport)
              .then(() => {
                this.saveLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.saveLoading = false;
              });
          }
        });
      },
      reportSubmit() {
        this.submitLoading = true;
        this.$http
          .post("basic", "inspectionReports/reportSubmit", this.inspectionReport)
          .then(() => {
            this.submitLoading = false;
            this.dialogVisible = false;
            this.$emit("save-success");
            this.$message.success("提交成功");
          });
      },
    },
  };
</script>

<style lang="scss">
  .inspectionReport {
    .printTable {
      width: 100%;
      margin: 2% auto;
      border-top: 1px solid #dddddd;
      border-left: 1px solid #dddddd;
      border-right: 1px solid #dddddd;

      .tableLabel {
        width: 130px;
        padding: 1%;
        background: #d1e6f5;
        border-bottom: 1px solid #dddddd;
      }

      td {
        width: 20%;
        padding: 1%;
        border-bottom: 1px solid #dddddd;
      }
    }
  }
  @media print {
    .printTable {
      width: 100%;
      margin: 2% auto;
      border-top: 1px solid #dddddd;
      border-right: 1px solid #dddddd;

      .tableLabel {
        width: 100px!important;
        padding: 1% 5px;
        background: #d1e6f5;
        border-left: 1px solid #dddddd;
        border-right: 1px solid #dddddd;
      }

      td {
        padding: 1% 5px;
        font-size: 12px;
        font-weight: lighter;
        border-bottom: 1px solid #dddddd;
      }
    }
  }

</style>
